module.exports = __webpack_public_path__ + "img/index_log.c2b229b9.png";